import { FC } from 'react'

import { Spacer } from '@syconium/little-miss-figgy'

import { Body } from '../CategoryProductSection/styles'

import { CategoryTitleSkeleton, Container, ResponsiveSkeleton, ResponsiveSpacer } from './styles'

const SkeletonRow = () => {
  return (
    <>
      <ResponsiveSkeleton height='85px' width='100%' />
      <ResponsiveSpacer height={8} />
    </>
  )
}

export const BulkSkeleton: FC = () => {
  return (
    <Body>
      <Container>
        <CategoryTitleSkeleton height='30px' width='150px' />
        <Spacer height={12} />
        {Array.from({ length: 8 }).map((_, index) => (
          <SkeletonRow key={index} />
        ))}
      </Container>
    </Body>
  )
}
